import { showErrorToast, showSuccessToast } from "../utils/Toast/toast";
import { handleViewVttDocument } from "../utils/function.js";

/**
 * Custom hook for shared VTT file handlers used in ChapterManagement and SubtitleManagement
 * @param {Object} params - Configuration object
 * @param {Function} params.handleFileUpload - Function to handle file upload
 * @param {Object|null} params.selectedLanguage - Currently selected language
 * @param {Function} params.setSelectedLanguage - State setter for selected language
 * @param {Function} params.setViewingFileId - State setter for viewing file ID
 * @returns {Object} - Object containing handler functions
 */
export const useVttFileHandlers = ({
  handleFileUpload,
  selectedLanguage,
  setSelectedLanguage,
  setViewingFileId,
}) => {
  /**
   * Handles language selection from dropdown
   * @param {Array} values - Selected language values
   */
  const handleLanguageSelect = (values) => {
    if (values && values.length > 0) {
      setSelectedLanguage(values[0]);
    } else {
      setSelectedLanguage(null);
    }
  };

  /**
   * Handles file input change event
   * @param {Event} event - File input change event
   */
  const handleFileInputChange = (event) => {
    const files = event.target.files;
    if (files && files.length > 0 && selectedLanguage) {
      handleFileUpload(files, selectedLanguage.id);
      // Reset the input value to allow uploading the same file again
      event.target.value = "";
    }
  };

  /**
   * Handles viewing a VTT document
   * @param {string} fileId - File ID
   * @param {string} fileInternalId - Internal file ID for state management
   */
  const handleViewDocument = async (fileId, fileInternalId) => {
    const result = await handleViewVttDocument(
      fileId,
      setViewingFileId,
      fileInternalId
    );

    if (result.success) {
      showSuccessToast("File opened successfully");
    } else {
      showErrorToast(result.error);
    }
  };

  return {
    handleLanguageSelect,
    handleFileInputChange,
    handleViewDocument,
  };
};

